<template>
  <div class="vue-app">
    <!-- Header -->
    <AppHeader />

    <!-- Main content -->
    <main class="bg-gascon-gray">
      <HeroSection />
      <PhoneImageSection />
      <CategoriesSection />
      <NewsSection :news="news" />
      <ContactSection />
      <GallerySection :images="galleryImages" />
      <TeamSection :members="teamMembers" />
    </main>

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import HeroSection from './sections/HeroSection.vue'
import PhoneImageSection from './sections/PhoneImageSection.vue'
import CategoriesSection from './sections/CategoriesSection.vue'
import NewsSection from './sections/NewsSection.vue'
import ContactSection from './sections/ContactSection.vue'
import GallerySection from './sections/GallerySection.vue'
import TeamSection from './sections/TeamSection.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    HeroSection,
    PhoneImageSection,
    CategoriesSection,
    NewsSection,
    ContactSection,
    GallerySection,
    TeamSection,
  },
  data() {
    return {
      news: [],
      galleryImages: [],
      teamMembers: [],
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const response = await fetch('/api/site_data')
        const data = await response.json()
        this.news = data.news
        this.galleryImages = data.gallery_images
        this.teamMembers = data.team_members
      } catch (error) {
        console.error('Error loading site data:', error)
      }
    }
  }
}
</script>
